import {createGroupRequest, deleteGroupRequest, getGroupsRequest} from "../../../services/api";
import {useEffect, useRef, useState} from "react";

const useGroupsInfo = () => {
  const [groups, setGroups] = useState([]);
  const successfulCreateGroupSubscriberRef = useRef();

  const getGroupsInfo = () => {
    return getGroupsRequest()
      .then(({data}) => setGroups(data));
  };

  const createGroup = (groupInfo) => {
    groupInfo.members_ids = [];
    return createGroupRequest(groupInfo)
      .then(({data}) => successfulCreateGroupSubscriberRef.current(data.id));
  };

  const deleteGroup = (groupId) => {
    return deleteGroupRequest(groupId)
      .then(() => getGroupsInfo());
  };

  useEffect(() => {
    getGroupsInfo();
  }, []);

  return {
    groups,
    createGroup,
    successfulCreateGroupSubscriberRef,
    deleteGroup
  };
};

export default useGroupsInfo;